import { apiClient } from '@shared/utils/api-client';
import type { FilterSet, CreateFilterSetDto, UpdateFilterSetDto } from '../types';

export const filterSetsApi = {
  getAll: async (): Promise<FilterSet[]> => {
    return apiClient.get<FilterSet[]>('/filter-sets');
  },

  getOne: async (id: number): Promise<FilterSet> => {
    return apiClient.get<FilterSet>(`/filter-sets/${id}`);
  },

  create: async (data: CreateFilterSetDto, file?: File): Promise<FilterSet> => {
    const formData = new FormData();
    formData.append('title', data.title);
    if (data.description) {
      formData.append('description', data.description);
    }
    formData.append('filters', JSON.stringify(data.filters));
    if (data.imageUrl) {
      formData.append('imageUrl', data.imageUrl);
    }
    if (file) {
      formData.append('image', file);
    }
    return apiClient.post<FilterSet>('/filter-sets', formData);
  },

  update: async (id: number, data: UpdateFilterSetDto, file?: File): Promise<FilterSet> => {
    const formData = new FormData();
    if (data.title !== undefined) {
      formData.append('title', data.title);
    }
    if (data.description !== undefined) {
      formData.append('description', data.description || '');
    }
    if (data.filters) {
      formData.append('filters', JSON.stringify(data.filters));
    }
    if (data.imageUrl) {
      formData.append('imageUrl', data.imageUrl);
    }
    if (data.shouldDeleteImage !== undefined) {
      formData.append('shouldDeleteImage', String(data.shouldDeleteImage));
    }
    if (file) {
      formData.append('image', file);
    }
    return apiClient.put<FilterSet>(`/filter-sets/${id}`, formData);
  },

  delete: async (id: number): Promise<void> => {
    return apiClient.delete(`/filter-sets/${id}`);
  },
};

